import BackendApiClient from './BackendApiClient';
import { DataWrappedResponse } from '../exports/Types';
import { OnSiteTable } from '../exports/Interfaces';

/** What a table's link resolves to (backend !2015, `GET /on-site-tables/{uuid}`). */
export enum OnSiteTableLinkState {
  Ok = 'ok',
  TableInactive = 'table_inactive',
  TableDeleted = 'table_deleted',
  OnSiteUnavailable = 'on_site_unavailable',
}

export interface OnSiteTableLink {
  state: OnSiteTableLinkState;
  company: { id: number; slug: string; franchise_id: number };
  /** No id: the shop takes it from the company's `on_site_tables`, matched by uuid. */
  table: Pick<OnSiteTable, 'uuid' | 'name' | 'is_active'>;
  single_table: boolean;
}

class OnSiteTableManager {
  /**
   * Resolves a table's link to its restaurant and table. `franchise` scopes it to the shop being
   * served, so a partner's domain never opens another partner's restaurant (404 instead).
   */
  public resolve(uuid: string, franchiseId: number | null | undefined): Promise<DataWrappedResponse<OnSiteTableLink>> {
    return BackendApiClient.request({
      method: 'GET',
      url: `/on-site-tables/${uuid}`,
      params: franchiseId ? { franchise: franchiseId } : undefined,
    });
  }
}

export default new OnSiteTableManager();
